import React, {useEffect, useState} from 'react'

const PurchaseUnit = ({record, rowIndex}) => {
    const [unit, setUnit] = useState('')

    useEffect(() => {
        if (record.unit) setUnit(record.unit)
    }, [record.stock])

    return (
        <React.Fragment>
            <span key={`unit-${record.key}`}>{unit}</span>
        </React.Fragment>
    )
}
export default PurchaseUnit